import React, { useState } from 'react';
import FormFields from '@pages/Forms/FormFields';
import './GeoNonGeo.css';
interface formDataType {
  [key: string]: any;
}

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState:any;
  handleFormChange:(value: string | boolean, key: string, id: any, option: formDataType, code?: number)=>void;
  onInputChange?:(value:string, key:string) => any;
};

const ZoneForm = ({ formData,formState,handleFormChange,onInputChange }: propsType) => {


  return (
    <div className="healtBlock_details_form_page">
      <form className="form_container_healtBlock_details">
        <FormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
          savedItems={[]}
          onInputChange={onInputChange}
        />
      </form>
    </div>
  );
};
export default ZoneForm;
